// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.teams-members__container {}*/
/*.teams-members__center {}*/
.teams-members__center__header {
    display: flex;
}
.teams-members__center__header__content {
    display: block;
    align-items: center;
}

.teams-members__center__header__content__icon  span{
    margin-right: var(--space-and-half);
    font-size: var(--space-and-half);
    color: var(--secondary-color);
    cursor: pointer;
}
/*.teams-members__center__header__content__title {}*/

.teams-merbers__table__content{
    background: white;
    padding: 27px;
    border-radius: 14px;
    margin-top: var(--space-x2);
    box-shadow: 0px 1px 4px 0px rgba(150, 150, 150, 0.25);
}

.teams-members__center__header__content__title__text {
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space-and-half) !important;
    line-height: calc( var(--space-and-half) + var(--space-quarter) ) !important;
    color: var(--primary-very-dark-color) ;
}

.teams-members__center__header__content__title__description{
    font-family: var(--primary-font) !important;
    font-style: normal;
    font-weight: var(--font-medium) !important;
    font-size: var(--space);
    line-height: 20px;
    letter-spacing: 0.0015em;
    color: var(--basic-gray-color);
    margin-top: var(--space);
}
.teams-members__center__header__button {
    margin-top: var(--space-and-half);    
}

.teams-members__center__header__button button span{
    text-transform: unset;    
}

.teams-merbers__center__header__button__content .icon-plus{
    margin-right: 10px;
}

.teams-merbers__center__header__button__content {
    display: flex;
    justify-content: space-around
}


.teams-members__staff-detail__container {
    margin-top: calc( var(--space-x2) + var(--space-half) );
    /* display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: var(--space-and-half); */
}

.teams-members__staff-detail__title {
    display: flex;
    margin-bottom: calc( var(--space-x2) + var(--space-half) );
    grid-column: 1 / span 5;
}
.teams-members__staff-detail__title span {
    font-size: var( --space-x2 );
    /* color: var( --secondary-color ); */
    margin-right: calc( var(--space) + var(--space-half) );
    cursor: pointer;
    margin-top: -3px;
}


@media screen and ( max-width: 1024px ) {
    
    .team {
        grid-template-areas: "center center center center center center center center center center center center ";
    }
    .team__right-container, .team__left-container {
        display: none;
    }

}

@media screen and ( max-width: 576px ) {
    
    .team {
        margin: 0;
    }

}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/team-members/TeamsMembersComponent.styles.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B,4BAA4B;AAC5B;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,6BAA6B;IAC7B,eAAe;AACnB;AACA,oDAAoD;;AAEpD;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,2CAA2C;IAC3C,4EAA4E;IAC5E,sCAAsC;AAC1C;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0CAA0C;IAC1C,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,wBAAwB;AAC5B;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb;AACJ;;;AAGA;IACI,uDAAuD;IACvD;;iCAE6B;AACjC;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,uBAAuB;AAC3B;AACA;IACI,4BAA4B;IAC5B,qCAAqC;IACrC,sDAAsD;IACtD,eAAe;IACf,gBAAgB;AACpB;;;AAGA;;IAEI;QACI,2GAA2G;IAC/G;IACA;QACI,aAAa;IACjB;;AAEJ;;AAEA;;IAEI;QACI,SAAS;IACb;;AAEJ","sourcesContent":["/*.teams-members__container {}*/\n/*.teams-members__center {}*/\n.teams-members__center__header {\n    display: flex;\n}\n.teams-members__center__header__content {\n    display: block;\n    align-items: center;\n}\n\n.teams-members__center__header__content__icon  span{\n    margin-right: var(--space-and-half);\n    font-size: var(--space-and-half);\n    color: var(--secondary-color);\n    cursor: pointer;\n}\n/*.teams-members__center__header__content__title {}*/\n\n.teams-merbers__table__content{\n    background: white;\n    padding: 27px;\n    border-radius: 14px;\n    margin-top: var(--space-x2);\n    box-shadow: 0px 1px 4px 0px rgba(150, 150, 150, 0.25);\n}\n\n.teams-members__center__header__content__title__text {\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space-and-half) !important;\n    line-height: calc( var(--space-and-half) + var(--space-quarter) ) !important;\n    color: var(--primary-very-dark-color) ;\n}\n\n.teams-members__center__header__content__title__description{\n    font-family: var(--primary-font) !important;\n    font-style: normal;\n    font-weight: var(--font-medium) !important;\n    font-size: var(--space);\n    line-height: 20px;\n    letter-spacing: 0.0015em;\n    color: var(--basic-gray-color);\n    margin-top: var(--space);\n}\n.teams-members__center__header__button {\n    margin-top: var(--space-and-half);    \n}\n\n.teams-members__center__header__button button span{\n    text-transform: unset;    \n}\n\n.teams-merbers__center__header__button__content .icon-plus{\n    margin-right: 10px;\n}\n\n.teams-merbers__center__header__button__content {\n    display: flex;\n    justify-content: space-around\n}\n\n\n.teams-members__staff-detail__container {\n    margin-top: calc( var(--space-x2) + var(--space-half) );\n    /* display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: var(--space-and-half); */\n}\n\n.teams-members__staff-detail__title {\n    display: flex;\n    margin-bottom: calc( var(--space-x2) + var(--space-half) );\n    grid-column: 1 / span 5;\n}\n.teams-members__staff-detail__title span {\n    font-size: var( --space-x2 );\n    /* color: var( --secondary-color ); */\n    margin-right: calc( var(--space) + var(--space-half) );\n    cursor: pointer;\n    margin-top: -3px;\n}\n\n\n@media screen and ( max-width: 1024px ) {\n    \n    .team {\n        grid-template-areas: \"center center center center center center center center center center center center \";\n    }\n    .team__right-container, .team__left-container {\n        display: none;\n    }\n\n}\n\n@media screen and ( max-width: 576px ) {\n    \n    .team {\n        margin: 0;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
